<template>
  <div id="app">
    <!-- 登录和注册页面使用独立布局 -->
    <div v-if="isAuthPage" class="auth-layout">
      <router-view />
    </div>
    
    <!-- 其他页面使用带侧边栏的布局 -->
    <div v-else class="layout-container">
      <!-- 移动端遮罩层 -->
      <div v-if="isMobileMenuOpen" class="mobile-overlay" @click="closeMobileMenu"></div>
      
      <div class="sidebar" :class="{ 'mobile-open': isMobileMenuOpen }">
        <div class="logo">知弈题库</div>
        <nav>
          <router-link to="/profile" class="nav-item" @click="closeMobileMenu">
            <i class="fas fa-user"></i>
            个人中心
          </router-link>
          <router-link to="/question-bank" class="nav-item" @click="closeMobileMenu">
            <i class="fas fa-search"></i>
            题库搜索
          </router-link>
          <router-link to="/exported-courses" class="nav-item" @click="closeMobileMenu">
            <svg viewBox="0 0 1024 1024" fill="currentColor" aria-hidden="true">
              <path d="M785.066667 68.266667v341.333333c0 20.48-13.653333 34.133333-34.133334 34.133333-6.826667 0-13.653333 0-20.48-6.826666L614.4 341.333333 498.346667 436.906667c-13.653333 6.826667-34.133333 6.826667-47.786667-6.826667C443.733333 423.253333 443.733333 416.426667 443.733333 409.6V68.266667H170.666667c-40.96 0-68.266667 27.306667-68.266667 68.266666v750.933334c0 40.96 27.306667 68.266667 68.266667 68.266666h682.666666c40.96 0 68.266667-27.306667 68.266667-68.266666V136.533333c0-40.96-27.306667-68.266667-68.266667-68.266666h-68.266666zM170.666667 0h682.666666c75.093333 0 136.533333 61.44 136.533334 136.533333v750.933334c0 75.093333-61.44 136.533333-136.533334 136.533333H170.666667c-75.093333 0-136.533333-61.44-136.533334-136.533333V136.533333C34.133333 61.44 95.573333 0 170.666667 0z m68.266666 68.266667h68.266667v887.466666H238.933333V68.266667z m273.066667 0v266.24l61.44-47.786667c27.306667-20.48 61.44-20.48 81.92 0l61.44 47.786667V68.266667H512z" fill="currentColor"></path>
            </svg>
            浏览课程
          </router-link>
          <a
            href="https://docs.ocsjs.com/"
            target="_blank"
            rel="noopener noreferrer"
            class="nav-item external-nav-item"
            @click="closeMobileMenu"
          >
            <svg viewBox="0 0 800 800" shape-rendering="geometricPrecision" xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true">
              <g stroke="none">
                <g>
                  <path d="m382.29066,36c12.1533,0 24.30713,0 36.46043,0c90.68231,5.71443 168.8118,39.84485 234.3885,102.39137c6.51079,6.54676 13.02158,13.09353 19.53237,19.64029c0.3021,0.7479 0.21355,1.44657 -0.26043,2.09496c-43.79419,43.2521 -87.37482,86.81007 -130.7367,130.67338c34.98118,48.09304 44.96613,101.07835 29.94964,158.9554c-2.51056,8.36991 -5.46386,16.57483 -8.85468,24.61583c-11.80641,-11.87164 -23.6123,-23.74275 -35.41871,-35.61439c13.18878,-52.67211 0.77504,-98.15064 -37.24173,-136.43453c-36.96359,-31.76751 -79.15352,-41.71859 -126.56979,-29.85324c-41.61073,13.20927 -70.51864,40.18193 -86.72374,80.91799c-6.98269,18.77193 -9.58701,38.15034 -7.81295,58.13525c1.00631,9.21627 2.5689,18.29427 4.68777,27.23453c-11.63973,11.79151 -23.35916,23.48821 -35.15827,35.09065c-21.92522,-50.63109 -21.49134,-101.08463 1.30216,-151.36115c20.91423,-42.50368 53.29421,-72.44438 97.14101,-89.82158c50.90345,-17.98841 100.38547,-14.67103 148.44605,9.95108c8.21037,4.69377 16.1103,9.84371 23.69928,15.45036c32.46697,-32.64635 64.93603,-65.29322 97.40144,-97.93957c0.34898,-0.34934 0.34898,-0.69815 0,-1.04748c-57.13558,-48.60893 -123.37221,-74.18514 -198.70936,-76.72806c-93.66529,-0.69134 -172.9235,32.56622 -237.77411,99.77266c-68.72219,76.44733 -95.98068,166.00705 -81.77554,268.67914c16.97441,95.0548 65.67514,168.46653 146.10216,220.2331c79.79209,47.47712 164.51937,58.99942 254.1813,34.56691c44.38224,-13.2297 83.96838,-34.87591 118.75684,-64.94389c-10.32872,-10.38578 -20.66265,-20.77681 -30.99137,-31.16259c-59.52895,49.04311 -127.84903,70.08178 -204.95972,63.11079c-60.75662,-6.95528 -113.36382,-31.2202 -157.82159,-72.8c-7.38636,-7.33761 -14.67845,-14.75902 -21.87626,-22.25899c32.81439,-33.34502 65.80223,-66.51511 98.96403,-99.51079c8.08119,8.03838 16.24104,15.98196 24.48058,23.83022c36.73076,29.45415 77.87896,38.00893 123.44461,25.66331c28.33497,-8.68886 51.16649,-25.0123 68.49353,-48.96978c0.55316,-0.73271 1.24747,-1.25645 2.08345,-1.57122c11.09803,10.54814 21.94918,21.37178 32.55396,32.47194c-39.25226,48.79171 -90.29687,71.92535 -153.13382,69.39568c-35.57705,-2.66584 -67.52316,-14.71189 -95.83885,-36.13813c-0.52086,-0.34934 -1.04173,-0.34934 -1.56259,0c-11.28555,11.3479 -22.57057,22.6937 -33.85612,34.04317c57.26267,45.04173 121.67576,60.23022 193.24029,45.56547c35.89634,-8.22797 67.84245,-24.11304 95.83885,-47.66043c10.48029,-9.57922 20.72515,-19.44127 30.73094,-29.59137c31.50702,31.41922 62.93071,62.92748 94.27626,94.53525c0.30731,0.24092 0.65629,0.32996 1.04173,0.26187c0.47399,0.64944 0.56253,1.34601 -0.26043,2.09496c-66.483,73.18233 -149.03775,113.8613 -247.67051,122.03166c-16.32021,0 -32.64094,0 -48.96115,0c-106.75354,-9.01358 -193.65074,-55.10279 -260.6921,-138.26763c-48.46769,-63.12127 -74.25041,-134.70095 -77.3482,-214.73381c0,-7.15797 0,-14.31541 0,-21.47338c3.87934,-92.60789 36.95416,-172.74026 99.22446,-240.39712c66.97677,-69.32278 148.66585,-107.03213 245.0662,-113.12806z" fill="currentColor"></path>
                </g>
                <g>
                  <path d="m696.37125,191.02734c0.79171,0.00576 1.39591,0.35457 1.82302,1.04748c38.54909,56.84056 59.81594,119.68949 63.80576,188.54676c0,12.91912 0,25.83772 0,38.75683c-4.00544,69.127 -25.44417,132.15086 -64.32662,189.07051c-0.43753,0.78561 -0.86984,0.95845 -1.30216,0.52374c-10.92771,-11.16092 -21.86584,-22.33755 -32.81439,-33.51942c25.06915,-38.32999 41.29925,-80.22927 48.70072,-125.69784c11.92777,-81.28827 -4.30754,-156.27018 -48.70072,-224.94676c11.24544,-11.04308 22.18357,-22.30351 32.81439,-33.7813z" fill="currentColor"></path>
                </g>
              </g>
            </svg>
            OCS网课助手
          </a>
        </nav>
        
        <div class="sidebar-footer">
          <div class="icp-info">
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
              豫ICP备2025139425号-1
            </a>
          </div>
        </div>
      </div>
      <div class="main-content">
        <div class="header">
          <!-- 移动端汉堡菜单按钮 -->
          <button class="mobile-menu-btn" @click="toggleMobileMenu">
            <i class="fas fa-bars"></i>
          </button>
          <div class="user-info">
            <span class="username">{{ username }}</span>
            <button @click="logout" class="logout-btn">退出登录</button>
          </div>
        </div>
        
        <!-- 公告栏 -->
        <div v-if="showAnnouncement" class="announcement-bar" :class="`announcement-${announcementType}`">
          <div class="announcement-content">
            <i class="announcement-icon" :class="getAnnouncementIcon()"></i>
            <div class="announcement-text" v-html="parsedAnnouncementText"></div>
            <button class="announcement-close" @click="closeAnnouncement">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
        
        <div class="content">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ANNOUNCEMENT_TEXT, ANNOUNCEMENT_TYPE, ANNOUNCEMENT_ENABLED } from './config/api'
import { marked } from 'marked'

export default {
  name: 'App',
  data() {
    return {
      username: '',
      userRole: '',
      isMobileMenuOpen: false,
      announcementText: ANNOUNCEMENT_TEXT,
      announcementType: ANNOUNCEMENT_TYPE,
      announcementEnabled: ANNOUNCEMENT_ENABLED,
      announcementClosed: false
    }
  },
  computed: {
    parsedAnnouncementText() {
      if (!this.announcementText) return ''
      return marked(this.announcementText, { breaks: true })
    },
    isLoggedIn() {
      return localStorage.getItem('user') !== null && localStorage.getItem('token') !== null
    },
    isAuthPage() {
      return this.$route.name === 'Login' || this.$route.name === 'Register' || this.$route.name === 'ForgotPassword'
    },
    isAdmin() {
      return this.userRole === 'admin'
    },
    showAnnouncement() {
      return this.announcementEnabled && 
             this.announcementText && 
             !this.announcementClosed && 
             this.isLoggedIn && 
             !this.isAuthPage
    }
  },
  created() {
    const userStr = localStorage.getItem('user')
    if (userStr) {
      const user = JSON.parse(userStr)
      this.username = user.username
      this.userRole = user.role || ''
    }
    
    // 检查公告是否已被关闭（基于会话存储，每次打开页面都重新显示）
    const announcementClosed = sessionStorage.getItem('announcementClosed')
    if (announcementClosed === 'true') {
      this.announcementClosed = true
    }
  },
  methods: {
    logout() {
      localStorage.removeItem('user')
      localStorage.removeItem('token')
      this.$router.push('/login')
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false
    },
    closeAnnouncement() {
      this.announcementClosed = true
      // 将关闭状态保存到sessionStorage，仅在当前会话中有效，重新打开浏览器后会重新显示
      sessionStorage.setItem('announcementClosed', 'true')
    },
    getAnnouncementIcon() {
      const iconMap = {
        'info': 'fas fa-info-circle',
        'warning': 'fas fa-exclamation-triangle',
        'success': 'fas fa-check-circle',
        'error': 'fas fa-times-circle'
      }
      return iconMap[this.announcementType] || 'fas fa-info-circle'
    }
  }
}
</script>

<style>
body {
  margin: 0;
  font-family: Arial, sans-serif;
}

#app {
  height: 100vh;
}

.layout-container {
  display: flex;
  height: 100vh;
}




.sidebar {
  width: 250px;
  background: #f9f9fb;
  color: #333;
  padding: 20px 0 0 0;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  position: relative;
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
}

.sidebar::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f9f9fb;
  opacity: 1;
  z-index: -1;
}

.logo {
  font-size: 26px;
  font-weight: bold;
  text-align: center;
  padding: 25px 0;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 10px;
  color: #333;
  letter-spacing: 1px;
}

nav {
  flex: 1;
}

.sidebar-footer {
  margin-top: auto;
  padding: 20px 0;
  border-top: 1px solid #e5e7eb;
}

.sidebar-footer .icp-info {
  text-align: center;
}

.sidebar-footer .icp-info a {
  color: #6b7280;
  text-decoration: none;
  font-size: 11px;
  transition: color 0.3s ease;
}

.sidebar-footer .icp-info a:hover {
  color: #374151;
}

.nav-item {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  padding: 16px 25px;
  color: #333;
  text-decoration: none;
  transition: all 0.3s ease;
  margin: 5px 15px;
  border-radius: 10px;
  font-weight: 500;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
}

.nav-item i {
  margin-right: 12px;
  font-size: 16px;
  width: 20px;
  text-align: center;
}

.nav-item svg {
  margin-right: 12px;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.nav-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.35), transparent);
  transition: left 0.5s;
}

.nav-item:hover {
  background-color: #ececf1;
  transform: translateX(5px);
  box-shadow: 0 4px 15px rgba(15, 23, 42, 0.08);
}

.nav-item:hover::before {
  left: 100%;
}

.nav-item.router-link-active {
  background: #e0e1e6;
  color: #333;
  box-shadow: 0 4px 15px rgba(15, 23, 42, 0.08);
  transform: translateX(5px);
}

.nav-item.router-link-active::after {
  content: '';
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: 6px;
  height: 6px;
  background: #333;
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(51, 51, 51, 0.18);
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #f5f6fa;
}

.header {
  background-color: white;
  padding: 15px 30px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  font-size: 20px;
  color: #333;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

.mobile-menu-btn:hover {
  background-color: #f0f0f0;
}

.user-info {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 15px;
}

.username {
  font-weight: 500;
  color: #333;
}

.logout-btn {
  padding: 8px 16px;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.logout-btn:hover {
  background-color: #d32f2f;
}

.content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

/* 移动端遮罩层 */
.mobile-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
  display: none;
}

/* 移动端响应式设计 */
@media (max-width: 768px) {
  .layout-container {
    position: relative;
  }
  
  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    z-index: 999;
    transform: translateX(-100%);
    width: 280px;
  }
  
  .sidebar.mobile-open {
    transform: translateX(0);
  }
  
  .mobile-overlay {
    display: block;
  }
  
  .main-content {
    width: 100%;
    margin-left: 0;
  }
  
  .mobile-menu-btn {
    display: block;
  }
  
  .header {
    padding: 12px 20px;
  }
  
  .user-info {
    gap: 10px;
  }
  
  .username {
    display: none;
  }
  
  .logout-btn {
    padding: 6px 12px;
    font-size: 14px;
  }
  
  .content {
    padding: 15px;
  }
  
  .nav-item {
    padding: 18px 25px;
    font-size: 16px;
    margin: 8px 15px;
  }
  
  .nav-item i {
    font-size: 18px;
    margin-right: 15px;
  }
  
  .logo {
    font-size: 24px;
    padding: 30px 0;
  }
}

@media (max-width: 480px) {
  .sidebar {
    width: 260px;
  }
  
  .header {
    padding: 10px 15px;
  }
  
  .content {
    padding: 10px;
  }
  
  .nav-item {
    padding: 16px 20px;
    margin: 6px 10px;
  }
  
  .logo {
    font-size: 22px;
    padding: 25px 0;
  }
}

/* 触摸设备优化 */
@media (hover: none) and (pointer: coarse) {
  .nav-item:hover {
    transform: none;
  }
  
  .nav-item:active {
    background-color: #e0e1e6;
    transform: scale(0.98);
  }
  
  .mobile-menu-btn:hover {
    background-color: transparent;
  }
  
  .mobile-menu-btn:active {
    background-color: #e0e0e0;
  }
  
  .logout-btn:hover {
    background-color: #f44336;
  }
  
  .logout-btn:active {
    background-color: #c62828;
  }
}

/* 公告栏样式 */
.announcement-bar {
  padding: 12px 20px;
  margin: 0;
  border-left: 4px solid;
  animation: slideDown 0.3s ease-out;
}

.announcement-content {
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 100%;
}

.announcement-icon {
  font-size: 16px;
  flex-shrink: 0;
}

.announcement-text {
  flex: 1;
  font-size: 14px;
  line-height: 1.4;
  word-break: break-word;
}

/* Markdown 样式 */
.announcement-text p {
  margin: 0;
  display: inline;
}

.announcement-text strong {
  font-weight: bold;
}

.announcement-text em {
  font-style: italic;
}

.announcement-text code {
  background-color: rgba(0, 0, 0, 0.1);
  padding: 2px 4px;
  border-radius: 3px;
  font-family: 'Courier New', monospace;
  font-size: 12px;
}

.announcement-text a {
  color: inherit;
  text-decoration: underline;
}

.announcement-text a:hover {
  opacity: 0.8;
}

.announcement-text ul,
.announcement-text ol {
  margin: 0;
  padding-left: 20px;
  display: inline-block;
}

.announcement-text li {
  margin: 0;
}

.announcement-close {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background-color 0.2s;
}

.announcement-close:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.announcement-close i {
  font-size: 12px;
}

/* 不同类型的公告样式 */
.announcement-info {
  background-color: #e3f2fd;
  border-color: #2196f3;
  color: #1565c0;
}

.announcement-warning {
  background-color: #fff3e0;
  border-color: #ff9800;
  color: #ef6c00;
}

.announcement-success {
  background-color: #e8f5e8;
  border-color: #4caf50;
  color: #2e7d32;
}

.announcement-error {
  background-color: #ffebee;
  border-color: #f44336;
  color: #c62828;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 移动端公告栏适配 */
@media (max-width: 768px) {
  .announcement-bar {
    padding: 10px 15px;
  }
  
  .announcement-content {
    gap: 8px;
  }
  
  .announcement-text {
    font-size: 13px;
  }
  
  .announcement-icon {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .announcement-bar {
    padding: 8px 10px;
  }
  
  .announcement-text {
    font-size: 12px;
  }
  
  .announcement-close {
    width: 20px;
    height: 20px;
  }
  
  .announcement-close i {
    font-size: 10px;
  }
}
</style>

